import { lang } from '../../assets/lang'
import { buttonTypes } from '../../data'
import { getSelectOptionsFromArrayOfObjects } from '../../utils/functions'

const systemDefaultAction = [
  { key: 'web_url_birthday', value: lang.button_html_types_web_url_birthday },
  { key: 'web_url_email', value: lang.button_html_types_web_url_email },
  { key: 'web_url_phone', value: lang.button_html_types_web_url_phone },
  { key: 'web_url_location', value: lang.button_html_types_web_url_location },
  { key: 'UNSUBSCRIBE_QUICK_BOXER', value: lang.button_html_types_unsubscribe },
  { key: 'RESUBSCRIBE_QUICK_BOXER', value: lang.button_html_types_resubscribe },
  { key: 'YES_START_CHAT_WITH_HUMAN', value: lang.button_html_types_with_human },
  { key: 'YES_START_CHAT_WITH_BOT', value: lang.button_html_types_with_robot },
]

const isSequenceAddonAvailable = !!window.xitFlowBuilderData.sequence_addon

var isTeamAddonAvailable = !!window.xitFlowBuilderData.team_member_addon
var messenger_bot_connectivity_thirdparty_webhook = !!window.xitFlowBuilderData.messenger_bot_connectivity_thirdparty_webhook
var google_sheet_access = !!window.xitFlowBuilderData.google_sheet_access

var team_html_display_class = 'd-none';
if (isTeamAddonAvailable)
  team_html_display_class = '';

var thirdparty_webhook_display_class = 'd-none';
if(messenger_bot_connectivity_thirdparty_webhook)
  thirdparty_webhook_display_class = '';

var google_sheet_display_class = 'd-none';
if(google_sheet_access)
  google_sheet_display_class = '';

export let buttonHtml =
'<div id="button-button-text-group" class="form-group text-left mt-2">' + 
  '<label for="button-button-text">' + lang.button_html_label_button_text + '</label>' +
  '<input type="text" class="form-control" id="button-button-text" aria-describedby="button-button-text-help">' +
'</div>' +

'<div class="form-group text-left mt-2">' +
  '<label for="button-button-type">' + lang.button_html_label_button_type + '</label>' +
  '<select id="button-button-type" class="form-control select2">' +
    '<option value="" >' + lang.button_html_title_select + '</option>' +
    getSelectOptionsFromArrayOfObjects(buttonTypes) +
  '</select>' +
'</div>' +

'<div id="button-action-group" class="button-onDemand-field form-group text-left mt-2 d-none">' +
  '<label for="button-action-type">' + lang.button_html_label_action_type + '</label>' +
  '<select id="button-action-type" class="form-control select2">' +
    '<option value="" >' + lang.button_html_title_select + '</option>' +
    getSelectOptionsFromArrayOfObjects(systemDefaultAction) +
  '</select>' +
'</div>' +

'<div id="button-type-postback-group" class="button-onDemand-field form-group text-left mt-2 d-none">' + 
  '<label for="button-type-postback">' + lang.button_html_label_postback_id + '</label>' +
  '<select id="button-type-postback" class="form-control select2">' +
    '<option value="" selected>' + lang.button_html_title_select + '</option>' +
  '</select>' +
'</div>' +

'<div id="button-type-weburl-group" class="button-onDemand-field form-group text-left mt-2 d-none">' + 
  '<label for="button-type-weburl">' + lang.button_html_label_web_url + '</label>' +
  '<input type="text" class="form-control" id="button-type-weburl" aria-describedby="button-type-weburl-help">' +
'</div>' +

'<div id="button-type-call-group" class="button-onDemand-field form-group text-left mt-2 d-none">' + 
  '<label for="button-type-call">' + lang.button_html_label_mobile + '</label>' +
  '<input type="text" class="form-control" id="button-type-call" aria-describedby="button-type-call-help">' +
'</div>' +

'<div id="button-type-webview-group" class="button-onDemand-field form-group text-left mt-2 d-none">' + 
  '<label for="button-type-webview">' + lang.button_html_label_webview_url + '</label>' +
  '<input type="text" class="form-control" id="button-type-webview" aria-describedby="button-type-webview-help">' +
'</div>'

if(isSequenceAddonAvailable){
  buttonHtml += 
  '<div class="form-row">'+
    '<div class="form-group only-for-send-message text-left mt-2 button-onDemand-field d-none col">' +
      '<div class="d-flex justify-content-between">' +
        '<label for="new-button-choose-label">' + lang.button_html_add_label + '</label>' +
        '<span class="text-small text-primary text-underline" data-toggle="tooltip" data-original-title="' + lang.postback_html_label_create_new_info + '"><i class="fas fa-plus-circle"></i> ' + lang.postback_html_label_create_new + '</span>' +
      '</div>' + 
      '<select id="new-button-choose-label" class="form-control select2" multiple="">' +
      '</select>' +
    '</div>' +

    '<div class="form-group only-for-send-message text-left mt-2 button-onDemand-field d-none col">' +
      '<div class="d-flex justify-content-between">' +
        '<label for="new-button-remove-label">' + lang.button_html_remove_label + '</label>' +
      '</div>' + 
      '<select id="new-button-remove-label" class="form-control select2" multiple="">' +
      '</select>' +
    '</div>' +
  '</div>' +
  '<div class="form-row">'+
    '<div class="form-group only-for-send-message text-left mt-2 button-onDemand-field d-none col">' +
      '<label for="new-button-choose-sequence">' + lang.button_html_add_sequence + '</label>' +
      '<select id="new-button-choose-sequence" class="form-control select2">' +
      '</select>' +
    '</div>' +

    '<div class="form-group only-for-send-message text-left mt-2 button-onDemand-field d-none col">' +
      '<label for="new-button-remove-sequence">' + lang.button_html_remove_sequence + '</label>' +
      '<select id="new-button-remove-sequence" class="form-control select2">' +
      '</select>' +
    '</div>' +
  '</div>'
}

buttonHtml += 
  '<div class="form-row '+ team_html_display_class +'">'+
    '<div class="form-group only-for-send-message text-left mt-2 button-onDemand-field d-none col">' +
      '<label for="new-button-conversation-group">' + lang.button_html_conversation_group + '</label>' +
      '<select id="new-button-conversation-group" class="form-control select2">' +
      '</select>' +
    '</div>' +

    '<div class="form-group only-for-send-message text-left mt-2 button-onDemand-field d-none col">' +
      '<label for="new-button-conversation-user">' + lang.button_html_conversation_user + '</label>' +
      '<select id="new-button-conversation-user" class="form-control select2">' +
      '</select>' +
    '</div>' +
  '</div>' +

  '<div class="form-row '+ thirdparty_webhook_display_class +'">'+
    '<div class="form-group only-for-send-message text-left mt-2 col-12 d-none">' + 
      '<label for="reference-webhook-url">' + lang.button_html_label_webhook_url + '</label>' +
      '<input type="text" class="form-control" id="reference-webhook-url" aria-describedby="button-button-text-help">' +
    '</div>' +
  '</div>' +

  '<div class="form-row '+ google_sheet_display_class +'">'+
    '<div class="form-group only-for-send-message text-left mt-2 col-12 d-none">' + 
      '<label for="button-google-sheets">' + lang.button_html_google_sheet_add + '</label>' +
      '<select id="button-google-sheets" class="form-control select2" multiple="">' +
      '</select>' +
    '</div>' +
  '</div>'
